/* eslint-disable import/prefer-default-export */

import {
  GET_USER,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  GET_USER_COMPLETED_COURSES,
  GET_USER_COMPLETED_COURSES_SUCCESS,
  GET_USER_COMPLETED_COURSES_FAIL,
  GET_USER_PUBLIC_NOTES,
  GET_USER_PUBLIC_NOTES_SUCCESS,
  GET_USER_PUBLIC_NOTES_FAIL,
  GET_USER_PUBLIC_CERTIFICATES,
  GET_USER_PUBLIC_CERTIFICATES_SUCCESS,
  GET_USER_PUBLIC_CERTIFICATES_FAIL,
  RESET_USER,
  GET_USER_DOCUMENTS,
  GET_USER_DOCUMENTS_SUCCESS,
  GET_USER_DOCUMENTS_FAIL,
} from '../constants';
import { buildQuery } from '../helpers';

export function getUser(id, includingArchived) {
  return {
    types: [GET_USER, GET_USER_SUCCESS, GET_USER_FAIL],
    promise: fetch =>
      fetch(
        `/api/accounts/${id}${includingArchived ? '?includingArchived' : ''}`,
        {
          method: 'GET',
        },
      ),
  };
}

export function getCompletedCourses(id) {
  return {
    types: [
      GET_USER_COMPLETED_COURSES,
      GET_USER_COMPLETED_COURSES_SUCCESS,
      GET_USER_COMPLETED_COURSES_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/accounts/${id}/completed-courses`, {
        method: 'GET',
      }),
  };
}

export function getPublicNotes(id) {
  return {
    types: [
      GET_USER_PUBLIC_NOTES,
      GET_USER_PUBLIC_NOTES_SUCCESS,
      GET_USER_PUBLIC_NOTES_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/accounts/${id}/notes`, {
        method: 'GET',
      }),
  };
}

export function getPublicCertificates(id) {
  return {
    types: [
      GET_USER_PUBLIC_CERTIFICATES,
      GET_USER_PUBLIC_CERTIFICATES_SUCCESS,
      GET_USER_PUBLIC_CERTIFICATES_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/accounts/${id}/certificates`, {
        method: 'GET',
      }),
  };
}

export function getUserDocuments(userId) {
  const query = {
    userId,
    sort: 'createDate',
  };
  return {
    types: [
      GET_USER_DOCUMENTS,
      GET_USER_DOCUMENTS_SUCCESS,
      GET_USER_DOCUMENTS_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/user-documents/all?${buildQuery(query)}`, {
        method: 'GET',
      }),
  };
}

export function reset() {
  return {
    type: RESET_USER,
  };
}
